export const formatRelativeDate = (isoDateStr) => {
    const inputDate = new Date(isoDateStr);
    const now = new Date();

    // Clear time to compare only dates
    const input = new Date(inputDate.getFullYear(), inputDate.getMonth(), inputDate.getDate());
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffInMs = today - input;
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays < 1) return 'Today';
    if (diffInDays === 1) return '1 day ago';
    if (diffInDays <= 6) return `${diffInDays} days ago`;
    if (diffInDays === 7) return '1 week ago';

    // Format as "10 Jan ‘25"
    const options = { day: '2-digit', month: 'short' };
    const formattedDate = inputDate.toLocaleDateString('en-GB', options);
    const year = `'${inputDate.getFullYear().toString().slice(-2)}`;
    return `${formattedDate} ${year}`;
};
